export default "__VITE_ASSET__CjLx9ryh__"